const useAgeGateTypes = () => {
  const AGE_GATE_COMPLETED = "AGE_GATE_COMPLETED";

  const AGE_GATE_REMEMBER_DATA = "AGE_GATE_REMEMBER_DATA";

  return { AGE_GATE_COMPLETED, AGE_GATE_REMEMBER_DATA };
};

export default useAgeGateTypes;
